
import { Vue } from "vue-class-component";

export default class LoadingSpinnerComponent extends Vue {}
